
import Dribbble from "../../../assets/outline/Dribbble.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function DribbbleIcon({ className, dataTestid = "DribbbleIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Dribbble data-testid={dataTestid} className={classes} {...rest} />
  );
}
